var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-nav flex",class:( _obj = {}, _obj['pos-'+_vm.position] = true, _obj )},[_c('logo',{attrs:{"mode":"horizontal"}}),_c('div',{staticClass:"box grow flex nav-container"},[_c('vue-scroll',{staticClass:"box grow"},[_c('Nav',{attrs:{"mode":"horizontal"},on:{"push-page":_vm.pushPage}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }